// extracted by mini-css-extract-plugin
export var banner = "_rt-0";
export var settingRow = "_rt-2";
export var titleIcon = "_rt-1";